import AdyenCheckout from '@adyen/adyen-web';
import Mixpanel from './analytics/mixpanel';
import { MIXPANEL_EVENT } from './analytics/mixpanelUtils';

const BUTTON_ID = 'submitButton';
const ERROR_ID = 'errors';
const FOOTER_ID = 'footer';
const PAYMENT_CONTAINER_ID = 'dropinContainer';
const SUBMIT_GROUP_ID = 'submitGroup';

const ADYEN_PAYMENT_RESULT_AUTHORIZED = 'Authorised';

const Payment = (() => {
  let adyenDropIn;
  let redirectUrl;
  let paymentInfoValid = false;
  const submitButtonEl = document.getElementById(BUTTON_ID);

  const setRedirectUrl = (url) => {
    redirectUrl = url;
  };

  const getConfig = ({ sessionId, sessionData }) => {
    return {
      clientKey: process.env.ADYEN_CLIENT_KEY,
      environment: process.env.ADYEN_ENV,
      session: {
        id: sessionId,
        sessionData,
      },

      paymentMethodsConfiguration: {
        card: {
          hasHolderName: true,
          holderNameRequired: true,
          positionHolderNameOnTop: true,
        },
        threeDS2: {
          /*==
              Accepted values:
              '02': ['390px', '400px'] -  The default window size
              '01': ['250px', '400px']
              '03': ['500px', '600px']
              '04': ['600px', '400px']
              '05': ['100%', '100%']

              We use the fixed dimension variations as 05 option renders double scrollbars
              and CTA is hidden until users scroll down.

              Mobile = 01, Desktop/Tablet = 04
          */
          challengeWindowSize: window.innerWidth > 600 ? '04' : '01',
        },
        ideal: {
          showImage: true,
        },
      },
      showPayButton: false,
      locale: 'en_US',
      translations: {
        placeholder: {
          'creditCard.numberField.title': 'Card Number',
          'creditCard.numberField.placeholder': 'Card Number',
          'creditCard.holderName': 'Name on Card',
          'creditCard.holderName.placeholder': 'Name on Card',
          'creditCard.cvcField.title': 'Security Code',
          'creditCard.cvcField.placeholder': '',
          'creditCard.cvcField.placeholder.4digits': '',
          'creditCard.cvcField.placeholder.3digits': '',
          'creditCard.expiryDateField.title': 'Expiry Date',
          'error.va.sf-cc-dat.01': 'Invalid expiry date',
        },
      },
      beforeSubmit(data, component, actions) {
        submitButtonEl.disabled = true;
        submitButtonEl.classList.add('submit__btn--loading');
        actions.resolve(data);
      },
      onActionHandled({ componentType, actionDescription }) {
        const COMPONENT_TYPE_3DS = '3DS2Challenge';
        // To monitor: Use component type instead of specific action below as sometimes it return a different actionDescription
        // const ACTION_3DS_IFRAME_LOADED = 'challenge-iframe-loaded';
        if (componentType === COMPONENT_TYPE_3DS) {
          document.getElementById(SUBMIT_GROUP_ID).classList.add('hide');
        }
      },
      onPaymentCompleted: onPaymentCompleted,
      onError: onError,
      onChange: (state) => {
          if (state.isValid) {
            paymentInfoValid = true;
          }
      },
    };
  };

  const handleSubmitButton = () => {
    submitButtonEl.addEventListener('click', function () {
      adyenDropIn.submit();
      
      if (paymentInfoValid) {
        Mixpanel.trackMixpanelEvent(MIXPANEL_EVENT.SubscribePaymentPagePayNow);
      }
    });
  };

  const showElement = (id) => {
    document.getElementById(id).style.display = 'block';
  };

  const onPaymentCompleted = (result) => {
    const { resultCode } = result;

    if (resultCode === ADYEN_PAYMENT_RESULT_AUTHORIZED) {
      window.location.href = `${redirectUrl}?payment=true&status=OK`;
    } else {
      window.location.href = `${redirectUrl}?payment=true&status=Error`;
    }
  };

  const onError = (e) => {
    console.error('ERROR', e);
    showElement(ERROR_ID);
  };

  return {
    init: (sessionDetails) => {
      const { redirectUrl } = sessionDetails;
      setRedirectUrl(redirectUrl);

      const config = getConfig(sessionDetails);

      AdyenCheckout(config).then((adyenCheckout) => {
        adyenDropIn = adyenCheckout
          .create('dropin', {
            showStoredPaymentMethods: false,
            onReady: () => {
              showElement(FOOTER_ID);
              handleSubmitButton();
            },
          })
          .mount(`#${PAYMENT_CONTAINER_ID}`);
      });
    },
  };
})();

module.exports = Payment;
